import { render, staticRenderFns } from "./legendJhWorkStatus.vue?vue&type=template&id=80f24eca&scoped=true"
import script from "./legendJhWorkStatus.vue?vue&type=script&lang=ts"
export * from "./legendJhWorkStatus.vue?vue&type=script&lang=ts"
import style0 from "./legendJhWorkStatus.vue?vue&type=style&index=0&id=80f24eca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f24eca",
  null
  
)

export default component.exports